/**
 * Fields whose change can strand a future booking on the wrong station (RYDE-7929).
 * Nested paths address the form's `metadata` object, which react-hook-form keeps nested in dirtyFields.
 */
export const PASSENGER_STATION_FIELDS = [
  "sourceStation1Id",
  "sourceStation2Id",
  "destinationStation1Id",
  "destinationStation2Id",
  "metadata.sourceStation3Id",
  "metadata.destinationStation3Id",
] as const;

export const SHIFT_STATION_OPTION_FIELDS = [
  "metadata.stationOption",
  "metadata.stationOptionB",
] as const;
